import { render, staticRenderFns } from "./AssetsCreatedCard.vue?vue&type=template&id=2a8117cc&scoped=true&"
import script from "./AssetsCreatedCard.vue?vue&type=script&lang=js&"
export * from "./AssetsCreatedCard.vue?vue&type=script&lang=js&"
import style0 from "./AssetsCreatedCard.vue?vue&type=style&index=0&id=2a8117cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8117cc",
  null
  
)

export default component.exports